// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1eT3T","left":"InfoRow_left__2kZij"};